module.exports = __webpack_public_path__ + "static/media/cvfga.c16dc727.jpg";